// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"0e35eb6a","977":"96d5b7ce"}[chunkId] + ".chunk.js";
};